import { User } from '../types';

/**
 * Feature-gating vanuit de backend (`frontend_settings.features`).
 *
 * De server levert de al samengevoegde waarde uit de frontend-settings tabel:
 * de organisatiescope wint van de default-scope. Ontbreekt de key in beide,
 * dan geldt de default uit `FRONTEND_FEATURE_DEFAULTS` hieronder.
 *
 * Defaults staan bewust op één plek zodat elke callsite dezelfde uitkomst
 * geeft; geef geen defaults meer mee op de plek van aanroep.
 *
 * default false → uit tenzij expliciet op true gezet (nieuwe/beta features)
 * default true  → aan tenzij expliciet op false gezet (bestaande features)
 */
export const FRONTEND_FEATURE_DEFAULTS = {
    search_recordings: false,
    template_editing: true,
    smart_templates: false,
    template_suggestions: false,
    // Tijdelijke vergelijking; uitschakelen verbergt de keuze en gebruikt V3/Sonnet 5.
    summary_update_comparison: true,
    // Tijdelijk V2 voor eerste generatie; true schakelt alleen die call naar V3.
    summary_generation_v3: false,
} as const;

export type FrontendFeatureKey = keyof typeof FRONTEND_FEATURE_DEFAULTS;

export function isFrontendFeatureEnabled(
    user: User | null | undefined,
    key: FrontendFeatureKey
): boolean {
    const value = user?.frontend_settings?.features?.[key];
    return typeof value === 'boolean' ? value : FRONTEND_FEATURE_DEFAULTS[key];
}
